import React from "react";
import "../Styles/Return.css";
import { TiArrowBackOutline } from "react-icons/ti";
import { NavLink } from "react-router-dom";

function Return() {
  return (
    <div className="return-wrapper">
      <NavLink to="/" className="return-button">
        <TiArrowBackOutline size={20} />
        Return to home
      </NavLink>
    </div>
  );
}

export default Return;
